import { Component, EventEmitter, Output } from '@angular/core'

@Component({
  selector: 'app-layer-config',
  templateUrl: './layer-config-base.component.html',
  styleUrls: ['./layer-config-base.component.scss'],
  standalone: false,
})
export class LayerConfigComponent {}
